import type { TeachingElement } from "./TeachingElement";

/**
 * Базовая реализация TeachingElement.
 *
 * Хранит корневой DOM элемента.
 * Остальная логика реализуется наследниками.
 */
export abstract class BaseTeachingElement
    implements TeachingElement {

    protected root!: HTMLElement;

    public mount(): void {
    }

    public update(): void {
    }

    public unmount(): void {
    }

    public getRoot(): HTMLElement {

        return this.root;

    }

}